// document.addEventListener("DOMContentLoaded", function () {
//   const mainAddToCart = document.querySelector("button[type='submit'][name='add']");
//   if (!mainAddToCart) return;

//   mainAddToCart.addEventListener("click", function () {
//     setTimeout(() => {
//       const checked = document.querySelectorAll(".new-discount-check:checked");
//       if (!checked.length) return;

//       const items = [];

//       checked.forEach(chk => {
//         items.push({
//           id: chk.dataset.variant,
//           quantity: 1
//         });
//       });

//       // Add all items in one API call
//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ items })
//       })
//       .then(r => r.json())
//       .then(() => {
//         // Refresh cart drawer
//         document.body.dispatchEvent(new CustomEvent("cart:refresh"));
//       })
//       .catch(err => console.error("Upsell error:", err));
//     }, 300);
//   });

// });




 



 
//      var cartPriceCC = document.getElementById("custom-cart-price");
//     var qualityInputCC = document.querySelector(".quantity__input");
//     var productPriceCC = document.getElementById("product-Price");
//     productPriceCC = document.getElementById("product-Price").innerText;
//     let priceValueCC = parseFloat(productPriceCC.replace(/[^\d.,]/g, "").replace(",", "."));
    
 
//     qualityInputCC.addEventListener("change", (event) => {
//         let priceMain = priceValueCC *  event.target.value;
//         cartPriceCC.innerText = '€' + priceMain.toFixed(2) + 'EUR';
//     });


//      cartPriceCC.innerText = '€' + priceValueCC.toFixed(2) + 'EUR';

function qs(sel, root=document){ return root.querySelector(sel); }
function qsa(sel, root=document){ return Array.from(root.querySelectorAll(sel)); }

function safeSetHTML(el, html){
  if (!el) return false;
  el.innerHTML = html;
  return true;
}

function on(el, evt, fn){
  if (!el) return false;
  el.addEventListener(evt, fn);
  return true;
}


// ADD TO CART
function addToCart(variantId, quantity = 1) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
   showCustomCart()
  })
  .catch(error => console.error('Error adding to cart:', error));
}

// REMOVE FROM CART
function removeByVariantId(variantId, qty = false) {

  setTimeout(() => {
  let valueQty = document.getElementById("qty-selecter").value;
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const item = cart.items.find(i => i.variant_id == variantId);
      if (!item) return console.log("Variant not in cart");
      console.log(item.line);
      
      // Remove the item using line number
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: qty ? 0 : valueQty
        })
      })
      .then(res => {
        showCustomCart()
      })
      .then(data => console.log("Removed item:", data));
    });

    }, 1000);
}

 
window.addEventListener("load", () => {
    var extraAddon = document.querySelectorAll(".new-discount-check");
    
    for (let index = 0; index < extraAddon.length; index++) {
            extraAddon[index].addEventListener("change", () => {
              console.log(extraAddon[index], extraAddon[index].checked);
              
                if (extraAddon[index].checked) {
                    addToCart(extraAddon[index].getAttribute('data-variant'))
                } else {
                    removeByVariantId(extraAddon[index].getAttribute('data-variant'), true)
                }
            })
    };

    showCustomCart()
})

 


function showCustomCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartList = document.getElementById('custom-cart-list');
      cartList.innerHTML = ''; // clear previous items

      cart.items.forEach(item => {
        const li = document.createElement('li');
        li.style.display = 'flex';
        li.style.justifyContent = 'space-between';
       

        const title = document.createElement('span');
        title.textContent = `${item.product_title}`; // include quantity

        const price = document.createElement('span');
        const lineTotal = ((item.price * item.quantity) / 100).toFixed(2); // total per line
        price.textContent = "€" + lineTotal;

        li.appendChild(title);
        li.appendChild(price);
        cartList.appendChild(li);
      });

      // Display cart total
      const formattedTotal = "€" + (cart.total_price / 100).toFixed(2);
      const totalPrice = document.getElementById('total-price');
      totalPrice.innerText = "Totaal: " + formattedTotal;
    });




     
// document.querySelector('.new-product-discount-inpus button').addEventListener('click', function(e) {
//     e.preventDefault();

//     const code = document.getElementById('discount_code').value.trim();
//     const infoBox = document.getElementById('coupen-code-info');

//      infoBox.innerText = code + ": Discount Apply On Checkout Page";

    
// });
 

}

// Call the function to render the cart
showCustomCart();


const checkbox = document.getElementById('avCheckbox');
  const button = document.getElementById('checkoutButton');

  checkbox.addEventListener('change', () => {
    button.disabled = !checkbox.checked;
  });

  // Optional: redirect to checkout when button is clicked
  button.addEventListener('click', () => {
    window.location.href = '/checkout';

    //     const code = document.getElementById('discount_code').value.trim();

    // if (checkbox.checked) {
    //   if (code) {
    //     window.location.href = '/checkout?discount=' + code;
    //   } else {
    //     window.location.href = '/checkout';
    //   }
      
    // }
    
  });